// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"f0bece104a1cd791ddbd","691":"2b09af24cf5b5206edb9"}[chunkId] + ".js";
};